import { useState } from 'react';
import { Image } from '@/component/Image';
import { useTranslations } from 'next-intl';

import styles from './SliderCard.module.css';
import { Link } from '@/i18n/routing';

export const SliderCasesCard = ({ item, bgGray }) => {
  const t = useTranslations();
  const { coverImage, title, slug, headline } = item;
  const [isImageReady, setIsImageReady] = useState(false);
  const onLoadCallBack = (e) => {
    setIsImageReady(true);
    typeof onLoad === 'function' && onLoad(e);
  };
  return (
    <div className="flex flex-col h-full">
      <div className={`${styles.card} border-none`}>
        <div className={`${styles.image} ${styles.image_cases}`}>
          {coverImage.url && (
            <Image
              className={`skeleton z-1 relative w-full opacity-0 transition-opacity duration-300 ${
                isImageReady ? 'opacity-100' : ''
              }`}
              height={310}
              width={310}
              alt={title}
              title={title}
              src={coverImage.url}
              style={{ width: 'auto' }}
              onLoad={onLoadCallBack}
            />
          )}
        </div>

        <div className="px-3 pt-4 pb-3 flex flex-col justify-between">
          <div className="space-y-2.5">
            <h3
              className="line-clamp-3 text-slate-700 text-xl leading-[normal] font-semibold tracking-tight"
              title={title}
            >
              {title}
            </h3>
            {headline && (
              <div className="line-clamp-3 text-slate-500 text-sm">
                {headline}
              </div>
            )}
            <Link
              className="inline-flex text-teal-700 text-sm underline leading-tight"
              href={slug}
            >
              {t('slider.cases.link')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
